import * as React from 'react';
import { findDOMNode } from 'react-dom';

export interface IProps {
  isActive: boolean;
  cssClass?: string;
  cssClassContainer?: string;
  onClickOutside?: (event: React.FocusEvent<HTMLDivElement>) => void;
  children?: React.ReactChild;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any;
  isShowCenterByParent?: boolean;
  parentWidth?: number;
}

export class Popover extends React.Component<IProps> {
  private readonly popoverRef = React.createRef<HTMLDivElement>();

  public constructor(props: IProps) {
    super(props);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly handleOutsideClick = (event: any): void => {
    const { isActive, onClickOutside } = this.props;
    // eslint-disable-next-line react/no-find-dom-node
    const root = findDOMNode(this.popoverRef.current);
    if (isActive && !root?.contains(event.target)) {
      event.stopPropagation();
      if (onClickOutside) {
        onClickOutside(event);
      }
    }
  };

  public componentDidMount(): void {
    document.addEventListener('mouseup', this.handleOutsideClick);
    document.addEventListener('mouseleave', this.handleOutsideClick);
  }

  public componentWillUnmount(): void {
    document.removeEventListener('mouseup', this.handleOutsideClick);
    document.removeEventListener('mouseleave', this.handleOutsideClick);
  }

  public render(): React.ReactNode {
    const { cssClass, cssClassContainer, children, style } = this.props;
    const styleInner = this.calcInCenterParentStyle();

    return (
      <div className={cssClassContainer} style={style}>
        <div className={cssClass} ref={this.popoverRef} style={styleInner}>
          {children}
        </div>
      </div>
    );
  }

  private readonly calcInCenterParentStyle = () => {
    const { isShowCenterByParent, parentWidth } = this.props;

    let style = {};
    if (isShowCenterByParent && this.popoverRef.current) {
      const parentWidthParam = parentWidth || 0;
      const { offsetWidth } = this.popoverRef.current;
      const left = ((offsetWidth - parentWidthParam) / 2) * -1;

      style = {
        ...style,
        left,
      };
    }

    return style;
  };
}
